"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeScreenTileDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class HomeScreenTileDto {
    constructor(params) {
        this.backgroundVideoUrl = "";
        this.title = "";
        this.type = "";
        this.value = "";
        this.hideIcon = false;
        this.hideBorder = false;
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.imageId = params.imageId;
        this.iconId = params.iconId;
        this.backgroundVideoUrl = params.backgroundVideoUrl;
        this.title = params.title;
        this.type = params.type;
        this.value = params.value;
        this.hideIcon = params.hideIcon;
        this.hideBorder = params.hideBorder;
        this.x = params.x;
        this.y = params.y;
        this.width = params.width;
        this.height = params.height;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
    }
}
exports.HomeScreenTileDto = HomeScreenTileDto;
//# sourceMappingURL=HomeScreenTileDto.js.map